export const SET_VERIFY_STOCKS_IMAGES  = `SET_VERIFY_STOCKS_IMAGES`;
export const REMOVE_VERIFY_STOCKS_IMAGES  = `REMOVE_VERIFY_STOCKS_IMAGES`;
export const REMOVE_ALL_VERIFY_STOCKS_IMAGES  = `REMOVE_ALL_VERIFY_STOCKS_IMAGES`;

